<pk-broker-modal>
	<ng-template #headerTemplate>
		<h5 class="modal-title" *ngIf="!submitted">Please tell us what you think</h5>
		<h5 class="modal-title" *ngIf="submitted">Thank you</h5>
	</ng-template>
	<ng-template #bodyTemplate>
		<div class="container-fluid" *ngIf="!submitted">
			<div class="row">
				<div class="col">
					<p>Dear Irene, we are committed to improving our Layered Purchasing Alerts.</p>
					<p class="mb-4">Please tell us what you think:<br><strong>Was that notification helpful to you?</strong></p>
				</div>
			</div>
			<div class="row">
				<div class="col form-element-container">
					<div class="custom-control custom-radio">
						<input
							type="radio"
							id="lpFeedbackYesLoved"
							name="lpFeedbackChoice"
							class="custom-control-input"
							[(ngModel)]="selectedChoice"
							[value]="'yes-loved'" />
						<label class="custom-control-label" for="lpFeedbackYesLoved">Yes! I loved it.</label>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col form-element-container">
					<div class="custom-control custom-radio">
						<input
							type="radio"
							id="lpFeedbackNoPrice"
							name="lpFeedbackChoice"
							class="custom-control-input"
							[(ngModel)]="selectedChoice"
							[value]="'no-not-competitive'" />
						<label class="custom-control-label" for="lpFeedbackNoPrice">No, the price is not competitive enough.</label>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col form-element-container">
					<div class="custom-control custom-radio">
						<input
							type="radio"
							id="lpFeedbackNoClientReady"
							name="lpFeedbackChoice"
							class="custom-control-input"
							[(ngModel)]="selectedChoice"
							[value]="'no-client-not-ready'" />
						<label class="custom-control-label" for="lpFeedbackNoClientReady">No, the client is not ready to purchase.</label>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col form-element-container">
					<div class="custom-control custom-radio">
						<input
							type="radio"
							id="lpFeedbackNoMarketTrends"
							name="lpFeedbackChoice"
							class="custom-control-input"
							[(ngModel)]="selectedChoice"
							[value]="'no-need-market-trends'" />
						<label class="custom-control-label" for="lpFeedbackNoMarketTrends">No, I need more market trend information.</label>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col form-element-container">
					<div class="custom-control custom-radio">
						<input
							type="radio"
							id="lpFeedbackNoTooLate"
							name="lpFeedbackChoice"
							class="custom-control-input"
							[(ngModel)]="selectedChoice"
							[value]="'no-too-late'" />
						<label class="custom-control-label" for="lpFeedbackNoTooLate">No, it came too late.</label>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col form-element-container">
					<div class="custom-control custom-radio">
						<input
							type="radio"
							id="lpFeedbackNoTooMany"
							name="lpFeedbackChoice"
							class="custom-control-input"
							[(ngModel)]="selectedChoice"
							[value]="'no-too-many-notifications'" />
						<label class="custom-control-label" for="lpFeedbackNoTooMany">No, I receive too many notifications.</label>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col form-element-container">
					<div class="custom-control custom-radio">
						<input
							type="radio"
							id="lpFeedbackOther"
							name="lpFeedbackChoice"
							class="custom-control-input"
							[(ngModel)]="selectedChoice"
							[value]="'other'" />
						<label class="custom-control-label" for="lpFeedbackOther">Other</label>
					</div>
				</div>
			</div>
			<div class="row" *ngIf="selectedChoice === 'other'">
				<div class="col form-element-container">
					<label for="otherSpecify">Please specify</label>
					<textarea class="form-control" id="otherSpecify" rows="6"></textarea>
				</div>
			</div>
		</div>
		<div class="container-fluid" *ngIf="submitted">
			<div class="row">
				<div class="col">
					<p class="mb-0">
						Thanks for taking the time to respond. Your feedback helps us improve Layered Purchasing Alerts.
					</p>
				</div>
			</div>
		</div>
	</ng-template>
	<ng-template #footerTemplate>
		<button *ngIf="!submitted" type="button" class="btn btn-primary w-100" (click)="submit()">Submit</button>
		<button *ngIf="submitted" type="button" class="btn btn-primary w-100" (click)="close()">Close</button>
	</ng-template>
</pk-broker-modal>
